import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Settings } from 'luxon';
import LocalStorageService, {
  LocalStorageKey,
} from '@shared/services/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class LuxonLocaleService {
  private readonly localeMap: Record<string, string> = {
    en: 'en-US',
    pl: 'pl',
    ua: 'uk',
  };

  private translateService = inject(TranslateService);
  private localStorageService = inject(LocalStorageService);

  /**
   * Initialize Luxon locale based on current user language
   */
  public initializeLuxonLocale(): void {
    const userLanguage = this.localStorageService.getItem(
      LocalStorageKey.UI_LANGUAGE,
    );

    // Set global Luxon locale
    Settings.defaultLocale = this.getLuxonLocale(userLanguage);

    // Listen for language changes
    this.translateService.onLangChange.subscribe((event) => {
      Settings.defaultLocale = this.getLuxonLocale(event.lang);
    });
  }

  /**
   * Get Luxon locale code from app language code
   */
  private getLuxonLocale(language: string | null): string {
    if (!language) {
      return 'en-US';
    }

    return this.localeMap[language] || 'en-US';
  }

  /**
   * Get current Luxon locale
   */
  public getCurrentLuxonLocale(): string {
    return Settings.defaultLocale || 'en-US';
  }
}
